/**
 * Altra sticky add-to-cart — shows the bar once the main buy button leaves the viewport.
 * The bar's button submits the main product form via its `form` attribute; this script only
 * handles visibility.
 */
class AltraStickyAtc extends HTMLElement {
  connectedCallback() {
    const formId = this.querySelector('[form]')?.getAttribute('form');
    const mainButton = document.querySelector(`form#${CSS.escape(formId)} [type="submit"], [form="${CSS.escape(formId)}"].product-form__submit`);
    const sentinel = mainButton || document.querySelector('.product-form__submit');

    if (!sentinel) return;

    this.observer = new IntersectionObserver(
      ([entry]) => {
        // Only show once the shopper has scrolled PAST the buy button, not before reaching it.
        const scrolledPast = entry.boundingClientRect.bottom < 0;
        this.hidden = entry.isIntersecting || !scrolledPast;
      },
      { threshold: 0 }
    );
    this.observer.observe(sentinel);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

if (!customElements.get('altra-sticky-atc')) {
  customElements.define('altra-sticky-atc', AltraStickyAtc);
}
